import { Divider, Stack, styled, Typography, Box } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { FC } from 'react';

import Visa from '@acorn-portal/shared/src/assets/images/Visa.svg';
import Mastercard from '@acorn-portal/shared/src/assets/images/Mastercard.svg?react';
import ApplePay from '@acorn-portal/shared/src/assets/images/ApplePay.svg?react';
import GooglePay from '@acorn-portal/shared/src/assets/images/GooglePay.svg?react';
import PayPal from '@acorn-portal/shared/src/assets/images/PayPal.svg?react';

const VendorImage = styled('div')(({ theme }) => ({
	flexShrink: 1,
	display: 'flex',
	justifyContent: 'center',
	'& svg': {
		height: 'auto',
		width: '80%',
		[theme.breakpoints.down('md')]: {
			width: '100%',
			maxWidth: '60px',
		},
	},
	'& img': {
		height: 'auto',
		width: '80%',
		[theme.breakpoints.down('md')]: {
			width: '100%',
			maxWidth: '80px',
		},
	},
}));

const CustomStack = styled(Stack)(({ theme }) => ({
	margin: 'auto',
	width: '100%',
	[theme.breakpoints.down('md')]: {
		flexWrap: 'nowrap',
		justifyContent: 'center',
		maxWidth: '100%',
		overflowX: 'hidden',
		paddingBottom: '12px',
		msOverflowStyle: 'none',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	},
}));

const PaymentVendors: FC = () => (
	<Box my={3} sx={{ textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
		<Typography
			variant='h4'
			sx={(theme) => ({
				verticalAlign: 'middle',
				display: 'inline-flex',
				fontSize: '1.3rem',
				fontWeight: '300',
				[theme.breakpoints.down('md')]: {
					alignItems: 'left',
					fontSize: '1.1rem',
					mb: 1,
				},
			})}
		>
			<LockOutlined /> Buy with confidence, we are secure.
		</Typography>
		<Box my={2}>
			<CustomStack
				direction='row'
				divider={<Divider orientation='vertical' flexItem />}
				spacing={{ xs: 1, sm: 1 }}
				justifyContent='center'
				alignItems='center'
				sx={(theme) => ({
					[theme.breakpoints.down('md')]: {
						'> *': {
							padding: '4px',
							flex: '1 1 0',
							minWidth: 0,
						},
						'& .MuiDivider-root': {
							display: 'none',
						},
					},
				})}
			>
				<VendorImage>
					<img src={Visa} alt='Visa' />
				</VendorImage>
				<VendorImage>
					<Mastercard />
				</VendorImage>
				<VendorImage>
					<PayPal />
				</VendorImage>
				<VendorImage>
					<ApplePay />
				</VendorImage>
				<VendorImage>
					<GooglePay />
				</VendorImage>
			</CustomStack>
		</Box>
	</Box>
);

export default PaymentVendors;
